import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrentSubscriptionModel } from '../models/current-subscription.model';
import { AppService } from '../app.service';

@Injectable()
export class CurrentSubscriptionService extends AppService<CurrentSubscriptionModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll() {
    const result = await this.getAllAsync(`Assinatura/Minhas`);
    return result;
  }

  async changePaymentMethod(subscriptionId: string, paymentMethodId: string) {
    const result = await this.putAsync(`Assinatura/${subscriptionId}/cartaocobranca`,
                                        { assinaturaId: subscriptionId, cartaoParaCobrancaId: paymentMethodId });
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/current-subscription.service.ts